import { ACTIVITEITEN_PARTNERS } from "../data/site";

function PartnerCard({ p }) {
  const testid = `activiteiten-partner-${p.name.toLowerCase().replace(/[^a-z]/g, "")}`;
  const cardCls =
    "group h-24 sm:h-28 rounded-2xl bg-white border border-[#ebd9b5] hover:border-[#ed6a1a] hover:shadow-md transition-all duration-300 flex items-center justify-center p-3 sm:p-4";

  const imgStyle = {};
  if (p.darkBg) imgStyle.filter = "invert(1) hue-rotate(180deg)";
  if (p.screen) imgStyle.mixBlendMode = "screen";

  const imgCls = `object-contain transition-transform duration-300 group-hover:scale-105 ${
    p.enlarge
      ? "max-h-[100%] max-w-[100%] scale-125"
      : p.shrink
        ? "max-h-[58%] max-w-[62%]"
        : "max-h-[78%] max-w-[82%]"
  }`;

  const img = (
    <img
      src={p.logo}
      alt={p.name}
      loading="lazy"
      style={Object.keys(imgStyle).length ? imgStyle : undefined}
      className={imgCls}
    />
  );

  if (!p.url) {
    return (
      <div
        data-testid={testid}
        title={p.name}
        className={`${cardCls} cursor-default`}
      >
        {img}
      </div>
    );
  }

  return (
    <a
      href={p.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      title={p.name}
      className={cardCls}
    >
      {img}
    </a>
  );
}

export default function ActiviteitenPartners({
  title = "Activiteitenpartners",
  text = "Deze partners helpen mee om het programma van Mechelen Beach vorm te geven.",
  bg = "bg-[#fdf8ec]",
}) {
  if (!ACTIVITEITEN_PARTNERS.length) return null;
  return (
    <section
      data-testid="activiteiten-partners"
      className={`${bg} py-14 sm:py-16`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-[#2b1c10]">
            {title}
          </h2>
          <p className="mt-4 text-sm sm:text-base text-[#6b5945] leading-relaxed">
            {text}
          </p>
        </div>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {ACTIVITEITEN_PARTNERS.map((p) => (
            <PartnerCard key={p.name} p={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
